import React from "react";
import AdminServizi from "../domains/adminPanel/adminServizi/AdminServizi";
import AdminPanelDom from "../domains/adminPanel/adminPanelDom";
import NewServicesAdmin from "./NewServicesAdmin";
class AdminPanelServizi extends React.Component {
  render() {
    return (
      <AdminPanelDom
        component={({MessaggiComponent})=><NewServicesAdmin forAdmin={true} MessaggiComponent={MessaggiComponent} />}
        {...this.props}
      />
    );
  }
}
export default AdminPanelServizi;